<template>
  <div id="wish-list" :dir="dir" class="wish-list">
    <surface-post
      v-for="(post, index) in currentPosts"
      :key="post.cid"
      :index="index"
      :post="post"
      :edit="inlinePostEdit"
    />
    <!-- This should stay under the same parent as the posts for sizing to work properly because it relies on stuffs like calc(25% - 16px) -->
    <div class="wish-sizer" />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import ConnectorsMixin from 'vuemixins/connectors_mixin'
import SortMixin from 'vuemixins/sort_mixin'
import SurfacePost from 'vuecomponents/surface_post'
import { $ } from 'bits/jquery'
import { scrollToPost, scrollNewPostIntoView } from 'surface/scroll_to_new_post'

export default {
  components: { SurfacePost },
  mixins: [ConnectorsMixin, SortMixin],
  data() {
    return {
      delayingUpdatePosts: false,
      currentPosts: [],
    }
  },
  computed: {
    ...mapState(['inlinePostEdit']),
    ...mapGetters('post', ['postEntitiesByCid', 'newestPostCid', 'currentSortedPosts']),
    ...mapGetters({
      dir: 'dir',
      format: 'format',
      canIWrite: 'canIWrite',
      newPostLocation: 'newPostLocation',
    }),
  },
  watch: {
    currentSortedPosts(value) {
      // Must do this so that vue won't rerender and crash shapeshift
      // TODO: remove jquery and eventually shapeshift. (see GridMixin)
      const $draggingElement = $(this.$el).find('.ss-dragged-child')
      if (!$draggingElement[0]) {
        this.currentPosts = value
      }
    },
    newestPostCid(postCid) {
      if (this.format === 'free') {
        scrollToPost(document.getElementById('wall-container'), this.postEntitiesByCid[postCid])
      } else if (this.format === 'stream' || this.format === 'grid' || this.format === 'matrix') {
        if (this.newPostLocation === 'bottom' && this.inlinePostEdit) {
          this.$nextTick(() => {
            scrollNewPostIntoView()
          })
        }
      }
    },
  },
  mounted() {
    this.currentPosts = this.currentSortedPosts
    if ((this.format === 'stream' || this.format === 'matrix') && this.canIWrite) {
      this.initializePostsSort(({ postCid, previousCid, nextCid }) => {
        this.sortedPost({ postCid, sectionId: null, previousCid, nextCid })
      })
    }
  },
  methods: {
    ...mapActions('post', ['sortedPost']),
    onGridFinishDragging() {
      if (this.delayingUpdatePosts) {
        this.delayingUpdatePosts = false
        this.currentPosts = this.currentSortedPosts
      }
    },
  },
}
</script>
